import './ConfirmationModel.scss';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { ConfirmationModelPopup } from '../../../../interfaces/modal.interface';
import { CheckCircle } from 'react-bootstrap-icons';

type TParams = { modal: ConfirmationModelPopup };

function ConfirmationModel({ modal }: TParams) {

  function bodyMessageHtml() {
    return {
      __html: modal.BodyMessageHtml
    };
  };

  return (
    <Modal
      className="modal-main-box"
      show={modal.Show}
      onHide={modal.HandleClose}
      backdrop="static"
      keyboard={false}>
      {modal.Title && modal.Title.length > 0 &&
        <Modal.Header closeButton className="text-center">
          <Modal.Title>{modal.Title}</Modal.Title>
        </Modal.Header>
      }

      { ((modal.BodyMessageHtml && modal.BodyMessageHtml.length > 0) || (modal.Message && modal.Message.length > 0) || (modal.ShowSuccessCheck)) &&
        <Modal.Body className="pt-40px">
          {modal.Message && modal.Message.length > 0 &&
            <div className={"label-message mb-3 w-100 " + (modal.BodyCentered ? "text-center" : "text-left")}>
              {modal.Message}
            </div>
          }
          {modal.BodyMessageHtml && modal.BodyMessageHtml.length > 0 &&
            <div className={"label-message mb-3 w-100 " + (modal.BodyCentered ? "text-center" : "text-left")} dangerouslySetInnerHTML={bodyMessageHtml()}></div>
          }
          {modal.ShowSuccessCheck &&
            <div className="label-message mb-3 w-100">
              <CheckCircle size="54" color="green"></CheckCircle>
            </div>
          }
        </Modal.Body>
      }
      <Modal.Footer>
        <Row className="w-100">
          <Col className="text-center">
            <Button variant="light" className={modal.OkVariant + " btn-default mr-2 w-100"} onClick={modal.HandleOk}>{modal.OkText}</Button>
          </Col>
        </Row>
        <Row className="w-100">
          <Col className="text-center">
            {modal.ShowCancel &&
              <Button variant="light" className={modal.CancelVariant + " btn-default w-100"} onClick={modal.HandleClose}>{modal.CancelText}</Button>
            }
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModel;